<sim-snackbar icon="fa-check-double" [duration]="data.duration">
	<ng-container label>
		{{ successMessage() | translate }}
	</ng-container>
</sim-snackbar>
